export const balancedCompute = 1/7;
export const balancedBlock = 16/7;
export const heavyCompute = 1/4;
export const heavyBlock = 30/7;
export const lightCompute = 1/14;
export const lightBlock = 16/14;
export const awsMin1 = 1;
export const awsMax1 = 10239;
export const awsMin2 = 10240;
export const awsMax2 = 51199;
export const awsMin3 = 51200;
export const awsMax3 = 153599;
export const awsMin4 = 153600;
